import { BillboardListFilters } from '@/features/billboards/components/list/BillboardListFilters';
import { BillboardListGrid } from '@/features/billboards/components/list/BillboardListGrid';
import { BillboardListPagination } from '@/features/billboards/components/list/BillboardListPagination';
import { BillboardListToolbar } from '@/features/billboards/components/list/BillboardListToolbar';
import { useBillboardsListPage } from '@/features/billboards/hooks/useBillboardsListPage';
import { Navbar } from '@/features/landing/components/Navbar';

type BillboardsPageProps = {
  embedded?: boolean;
};

export function BillboardsPage({ embedded = false }: BillboardsPageProps) {
  const {
    city,
    filters,
    filtersOpen,
    setFiltersOpen,
    billboards,
    pagination,
    isPending,
    isError,
    errorMessage,
    activeFilterCount,
    setPage,
    applyFilters,
    clearFilters,
  } = useBillboardsListPage();

  const total = pagination?.total ?? billboards.length;
  const totalPages = pagination?.pages ?? 1;
  const currentPage = pagination?.page ?? filters.page ?? 1;
  const itemsPerPage = pagination?.limit ?? filters.limit ?? 15;

  return (
    <div
      className={
        embedded
          ? 'w-full text-[#3A3660]'
          : 'min-h-screen bg-[#F3F2F9] text-[#3A3660]'
      }
    >
      {!embedded ? (
        <Navbar homeHref="/" city={city || undefined} authMode="signin" />
      ) : null}

      <main
        className={
          embedded
            ? 'mx-auto w-full max-w-7xl'
            : 'mx-auto max-w-[1200px] px-4 py-6 sm:px-6 sm:py-8'
        }
      >
        <BillboardListToolbar
          city={city || undefined}
          total={total}
          activeFilterCount={activeFilterCount}
          onOpenFilters={() => setFiltersOpen(true)}
          showNearbyLink={embedded}
        />

        <div className="mt-6 sm:mt-8">
          <BillboardListGrid
            items={billboards}
            isPending={isPending}
            isError={isError}
            errorMessage={errorMessage}
            detailBasePath={embedded ? '/screens' : '/billboard'}
            onRetry={() => window.location.reload()}
          />
        </div>

        <BillboardListPagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={total}
          itemsPerPage={itemsPerPage}
          onPageChange={setPage}
        />
      </main>

      <BillboardListFilters
        open={filtersOpen}
        filters={filters}
        city={city || undefined}
        onClose={() => setFiltersOpen(false)}
        onApply={applyFilters}
        onClear={clearFilters}
      />
    </div>
  );
}
